/* eslint-disable */

import request from '@/utils/request'

export function getListStatement(query) {
  return request({
    url: '/cashier-service/v1/debt-report',
    method: 'get',
    params: query
  })
}

export function downloadStatementList(query) {
  return request({
    url: '/cashier-service/v1/debt-report/export-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}
